/** Client-side origin comparison only. The API remains the authentication authority. */
export function accessTokenIdentity(token: string | null): string | null {
  if (!token) return null;
  try {
    const parts = token.split('.');
    if (parts.length !== 3 || !parts[1]) return null;
    const encoded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload: unknown = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '=')));
    if (!payload || typeof payload !== 'object') return null;
    const claims = payload as Record<string, unknown>;
    if (
      claims.type !== 'access' ||
      typeof claims.sub !== 'string' || !claims.sub ||
      typeof claims.tenantId !== 'string' || !claims.tenantId ||
      typeof claims.sessionId !== 'string' || !claims.sessionId
    ) return null;
    const epoch = claims.authVersion === undefined ? 0 : claims.authVersion;
    const purpose = claims.purpose === undefined ? 'NORMAL' : claims.purpose;
    if (!Number.isSafeInteger(epoch) || (epoch as number) < 0) return null;
    if (purpose !== 'NORMAL' && purpose !== 'PASSWORD_CHANGE') return null;
    return JSON.stringify([claims.sub, claims.tenantId, claims.sessionId, epoch, purpose]);
  } catch {
    return null;
  }
}
